export interface IDisputesState {
	filterDisputeCodes: Array<string> | null;
	filterAssignee: string,
	filterDue: boolean | null
}

const state: IDisputesState = {
	filterDisputeCodes: null,
	filterAssignee: 'all',
	filterDue: null
};

const mutations = {
	SET_FILTER_DISPUTE_CODES: (state, data) => {
		state.filterDisputeCodes = data;
	},
	SET_FILTER_ASSIGNEE: (state, data) => {
		state.filterAssignee = data;
	},
	SET_FILTER_DUE: (state, data) => {
		state.filterDue = data;
	}
};

export default {
	namespaced: true,
	state,
	mutations
};
